import * as documentationContractTypes from 'constants/enums/documentationContractTypes'

export default {
  [documentationContractTypes.CONSTRUCTION_CONTRACT_AGREEMENT]:
    'Dohoda o přistoupení ke smlouvě o výstavbě',
  [documentationContractTypes.CLIENT_CHANGE_AGREEMENT]:
    'Smlouva o klientské změně',
  [documentationContractTypes.AMENDMENT]: 'Dodatek',
  [documentationContractTypes.OTHER]: 'Ostatní',
  [documentationContractTypes.POWER_OF_ATTORNEY]: 'Plná moc',
} as const
